import { type ReactElement, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/auth'

export function RequireAuth({
  role,
  children,
}: {
  role?: 'ADMIN' | 'CLIENT'
  children: ReactNode
}): ReactElement {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <FullPageLoader />
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />
  if (role && user.role !== role) {
    return <Navigate to={user.role === 'ADMIN' ? '/admin' : '/client'} replace />
  }
  return <>{children}</>
}

export function RedirectIfAuth({ children }: { children: ReactNode }): ReactElement {
  const { user, loading } = useAuth()
  if (loading) return <FullPageLoader />
  if (user) return <Navigate to={user.role === 'ADMIN' ? '/admin' : '/client'} replace />
  return <>{children}</>
}

export function FullPageLoader(): ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="font-display text-3xl text-primary">MyPivot</div>
    </div>
  )
}
